"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResultsTableColumnMainResultProperty = exports.resultsTableColumnMainResultPropertyDefinition = void 0;
exports.resultsTableColumnMainResultPropertyDefinition = {
    view: { label: 'Results Table Column Main Result' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'orderedProperties',
            argument: [
                'results-table-column-name',
                'results-table-column-pinned',
                'results-table-column-title',
                'results-table-column-format-hint',
            ],
        },
    ],
    type: 'ordered-container',
    multiple: true,
    name: 'results-table-column-main-result',
};
const isResultsTableColumnMainResultProperty = (prop) => {
    return prop.name === exports.resultsTableColumnMainResultPropertyDefinition.name;
};
exports.isResultsTableColumnMainResultProperty = isResultsTableColumnMainResultProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0cy10YWJsZS1jb2x1bW4tbWFpbi1yZXN1bHQucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9yZXN1bHRzLXRhYmxlLWNvbHVtbi1tYWluLXJlc3VsdC5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLDhDQUE4QyxHQUFHO0lBQzVELElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxrQ0FBa0MsRUFBRTtJQUNuRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxJQUFJO1NBQ2Y7UUFDRDtZQUNFLElBQUksRUFBRSxtQkFBbUI7WUFDekIsUUFBUSxFQUFFO2dCQUNSLDJCQUEyQjtnQkFDM0IsNkJBQTZCO2dCQUM3Qiw0QkFBNEI7Z0JBQzVCLGtDQUFrQzthQUNuQztTQUNGO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsbUJBQW1CO0lBQ3pCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLGtDQUFrQztDQUNULENBQUE7QUFJMUIsTUFBTSxzQ0FBc0MsR0FBRyxDQUFDLElBQWtCLEVBQWdELEVBQUU7SUFDekgsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHNEQUE4QyxDQUFDLElBQUksQ0FBQTtBQUMxRSxDQUFDLENBQUE7QUFGWSxRQUFBLHNDQUFzQywwQ0FFbEQifQ==